// API Configuration
// Switch between local and production by updating the REACT_APP_API_URL in .env
// or by changing the default value here.

export const API_BASE_URL = process.env.REACT_APP_API_URL || "https://admin.torchbearer.co.ke";

export const API_ENDPOINTS = {
    UPCOMING_TRAININGS: `${API_BASE_URL}/api/training-programs/upcoming`,
    PAST_TRAININGS: `${API_BASE_URL}/api/training-programs/past`,
    UPCOMING_WEBINARS: `${API_BASE_URL}/api/training-programs/webinars/upcoming`,
    PAST_WEBINARS: `${API_BASE_URL}/api/training-programs/webinars/past`,
};
